// import React, { useContext, useEffect, useState } from "react";
import PageHeader from "../pageheader/PageHeader";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import React, { useState, useEffect, useContext, useRef } from "react";
import Datepicker from "../material/datepicker/Datepicker";
import DateRangePicker from "../material/datepicker/DateRangePicker";
import { useNavigate } from "react-router";
import Input from "../material/input/Input";
import Button from "../material/button/Button";
import deleteIcon from "../../asset/image/delete.svg";
import styles from "./InputData.module.css";
import "../../asset/css_scss/public/global.css";
import Pagination from "../pagination/Pagination";
import moment from "moment";
import "moment/locale/th";
import * as labPersonalApi from "../../service/labPersonalApi";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import DataTable from "react-data-table-component";
import { FaPlus, FaSearch, FaUpload } from "react-icons/fa";
import { HashLoader } from "react-spinners";

const customStyles = {
  rows: {
    style: {
      // override the row height
      "&:nth-child(even)": {
        background: "#effff4",
      },
      "&:not(:last-of-type)": {
        borderBottomWidth: "none",
      },
    },
  },
  headCells: {
    style: {
      // override the cell padding for head cells
      display: "flex",
      justifyContent: "center",
      background: "#B8DFC7",
      fontSize: 18,
      "@media (max-width: 800px)": {
        fontSize: 14,
      },
    },
  },
  cells: {
    style: {
      // override the cell padding for data cells
      display: "flex",
      justifyContent: "center",
      borber: "1px solid #B8DFC7",
    },
  },
};

export default function Newinputdata() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [topic, setTopic] = useState("นำเข้าข้อมูลการตรวจแลป");
  const auth = useRef(JSON.parse(localStorage.getItem("user")));

  const [optionTopic, setOptionTopic] = useState([
    {
      key: "นำเข้าข้อมูลการตรวจแลป",
      value: "นำเข้าข้อมูลการตรวจแลป",
    },
    {
      key: "ตรวจสอบประวัติการลงผลแลป",
      value: "ตรวจสอบประวัติการลงผลแลป",
    },
  ]);

  useEffect(() => {
    if (auth?.current?.auth?.ial?.level) {
      if (auth?.current?.auth?.ial?.level < 2) {
        navigate("/laboratory/manageprofileOperation", {
          state: {
            message:
              "ระดับการพิสูจน์ตัวตนต่ำเกิน กรุณาเพิ่มระดับการพิสูจน์ตัวตน",
          },
        });
      }
    }
  }, [navigate]);

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ข้อมูลผลการตรวจ", url: "/inputdata" },
  ];

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename="ข้อมูลผลการตรวจแลป" />

        <div className="flex gap-5 border-b">
          <div
            className={`lg:text-sm flex text-base items-center py-2 cursor-pointer ${
              topic === "นำเข้าข้อมูลการตรวจแลป"
                ? "text-[#42A1EF] font-bold border-b-[2px] border-[#42A1EF]"
                : "text-[#000000]"
            } hover:text-[#42A1EF]`}
            onClick={() => setTopic("นำเข้าข้อมูลการตรวจแลป")}
          >
            นำเข้าข้อมูลการตรวจแลป
          </div>
          <div
            className={`lg:text-sm flex text-base items-center py-2 cursor-pointer ${
              topic === "ตรวจสอบประวัติการลงผลแลป"
                ? "text-[#42A1EF] font-bold border-b-[2px] border-[#42A1EF]"
                : "text-[#000000]"
            } hover:text-[#42A1EF]`}
            onClick={() => setTopic("ตรวจสอบประวัติการลงผลแลป")}
          >
            ตรวจสอบประวัติการลงผลแลป
          </div>
        </div>

        {topic === "นำเข้าข้อมูลการตรวจแลป" ? (
          <ImportResultLab
            navigate={navigate}
            setLoading={setLoading}
            loading={loading}
          />
        ) : (
          <CheckResultLab
            setLoading={setLoading}
            navigate={navigate}
            loading={loading}
          />
        )}
      </div>
      {/* </div>
      </div> */}
    </>
  );
}

const ImportResultLab = ({ navigate, setLoading, loading }) => {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [inputvalue, setInputValue] = useState("");
  const [saveData, setSaveData] = useState([]);
  const [labInformList, setLabInformList] = useState([]);

  useEffect(() => {
    getImportLab();
  }, []);

  const [showList, setShowList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    let start = page * 10 - 10;

    setShowList(labInformList.slice(start, start + 10));
  }, [page, labInformList]);

  const getImportLab = async () => {
    setLoading(true);
    let res = await labPersonalApi.getImportLab();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setLabInformList(res["data"]["lab_information_list"]);

        let start = page * 10 - 10;
        setShowList(res.data?.lab_information_list.slice(start, start + 10));
        setTotalPage(Math.ceil(res.data?.lab_information_list?.length / 10));

        setSaveData(res["data"]["lab_information_list"]);
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const removeLab = async (i) => {
    if (!window.confirm(`คุณต้องการลบใช่หรือไม่`)) {
      return;
    }
    setLoading(true);
    let res = await labPersonalApi.removeLab(i["lab_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getImportLab();
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const handleChangeSearch = (value) => {
    setInputValue(value);
  };

  const handleClickSearch = () => {
    if (inputvalue !== "") {
      const filterData = labInformList.filter((item) => {
        return item["id_card"]
          ?.toLowerCase()
          .includes(inputvalue?.toLowerCase());
      });
      setLabInformList(filterData);
    } else {
      setLabInformList(saveData);
    }
  };

  const onClickExportExcel = () => {
    navigate("/inputdata/uploadExcelResults");
  };

  const onClickAddData = () => {
    navigate("/inputdata/AddIndividualData");
  };

  const columns = [
    {
      name: "ตัวเลือก",
      selector: (i) => (
        <div className={styles.imgDelete}>
          <img
            style={{ cursor: "pointer" }}
            src={deleteIcon}
            onClick={() => {
              removeLab(i);
            }}
          />
        </div>
      ),
    },
    {
      name: "รหัสตัวอย่าง",
      selector: (i) => <div>{i["testing_no"]}</div>,
      minWidth: "150px",
    },
    {
      name: "เลขบัตรประชาชนผู้ป่วย",
      selector: (i) => <div>{i["id_card"]}</div>,
      minWidth: "220px",
    },
    {
      name: "หมายเลข HN",
      selector: (i) => <div>{i["hn"]}</div>,
      minWidth: "150px",
    },
    {
      name: "คํานําหน้าชื่อผู้ป่วย",
      selector: (i) => <div>{i["sample_name"]["prefix"]}</div>,
      minWidth: "170px",
    },
    {
      name: "ชื่อผู้ป่วย",
      selector: (i) => <div>{i["sample_name"]["first_name"]}</div>,
    },
    {
      name: "นามสกุลผู้ป่วย",
      selector: (i) => <div>{i["sample_name"]["last_name"]}</div>,
      minWidth: "170px",
    },
    {
      name: "ชื่อหน่วยงานที่ส่งตัวอย่าง",
      selector: (i) => <div>{i["customer_name"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "เลขที่/ ตึกของหน่วยงาน",
      selector: (i) => <div>{i["customer_address"]["address"]}</div>,
      minWidth: "210px",
      wrap: true,
    },
    {
      name: "รหัสไปรษณีย์",
      selector: (i) => <div>{i["customer_address"]["post_code"]}</div>,
      minWidth: "160px",
    },
    {
      name: "วันที่เก็บตัวอย่าง",
      selector: (i) => <div>{i["collect_date"]}</div>,
      minWidth: "160px",
    },
    {
      name: "วันที่ส่งตัวอย่าง",
      selector: (i) => <div>{i["submit_date"]}</div>,
      minWidth: "160px",
    },
    {
      name: "วันที่รับตัวอย่าง",
      selector: (i) => <div>{i["receive_date"]}</div>,
      minWidth: "160px",
    },
    {
      name: "วันที่ตรวจ",
      selector: (i) => <div>{i["testing_date"]}</div>,
      minWidth: "160px",
    },
    {
      name: "ชนิดของตัวอย่าง",
      selector: (i) => <div>{i["category"]}</div>,
      minWidth: "160px",
      wrap: true,
    },
    {
      name: "เลขที่ใบรายงานผล",
      selector: (i) => <div>{i["report_no"]}</div>,
      minWidth: "180px",
    },
    {
      name: "วันที่รายงานผล",
      selector: (i) => <div>{i["report_date"]}</div>,
      minWidth: "160px",
    },
    {
      name: "วันที่ยืนยันผล",
      selector: (i) => <div>{i["approve_date"]}</div>,
      minWidth: "160px",
    },
    {
      name: "เวลาที่ยืนยันผล",
      selector: (i) => <div>{i["approve_time"]}</div>,
      minWidth: "160px",
    },
    {
      name: "ชื่อการทดสอบ",
      selector: (i) => <div>{i["expr2"]}</div>,
      minWidth: "350px",
      wrap: true,
    },
    {
      name: "ผลการทดสอบ",
      selector: (i) => <div>{i["testing_result"]}</div>,
      minWidth: "300px",
      wrap: true,
    },
    {
      name: "สรุปผลการทดสอบ",
      selector: (i) => <div>{i["testing_result_type"]}</div>,
      minWidth: "220px",
      wrap: true,
    },
    {
      name: "วิธีการทดสอบ",
      selector: (i) => <div>{i["testing_method"]}</div>,
      minWidth: "220px",
      wrap: true,
    },
    {
      name: "ชื่อผู้ตรวจ",
      selector: (i) => (
        <div>
          {i["analyst"]["prefix"]} {i["analyst"]["first_name"]}{" "}
          {i["analyst"]["last_name"]}
        </div>
      ),
      minWidth: "250px",
    },
    {
      name: "ชื่อผู้รับรองผล",
      selector: (i) => (
        <div>
          {i["approver"]["prefix"]} {i["approver"]["first_name"]}{" "}
          {i["approver"]["last_name"]}
        </div>
      ),
      minWidth: "250px",
    },
  ];

  return (
    <>
      <div className={styles.aligntitle}>
        <div className={styles.alignInput}>
          <div className={styles.inputData} style={{ marginRight: "2%" }}>
            <Input
              placeholder="ค้นหาด้วยเลขบัตรประชาชน"
              value={inputvalue}
              setValue={handleChangeSearch}
              style={{ borderRadius: "5px" }}
            />
          </div>
          <Button
            onClick={handleClickSearch}
            style={{ margin: "0", borderRadius: "5px", maxWidth: "200px" }}
          >
            <FaSearch style={{ width: "18px" }} />
            <div style={{ marginLeft: "10px" }}>ค้นหา</div>
          </Button>
        </div>

        <div className={styles.alignButton}>
          <Button
            onClick={onClickExportExcel}
            style={{
              margin: "0",
              borderRadius: "5px",
              maxWidth: "200px",
              background: "#f0f9ff",
              color: "#42a1ef",
            }}
          >
            <FaUpload style={{ width: "18px" }} />
            <div style={{ marginLeft: "10px" }}>อัปโหลดไฟล์ excel</div>
          </Button>
          <Button
            onClick={onClickAddData}
            style={{ margin: "0", borderRadius: "5px", maxWidth: "200px" }}
          >
            <FaPlus style={{ width: "18px" }} />
            <div style={{ marginLeft: "10px" }}>ลงข้อมูลรายบุคคล</div>
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="flex flex-col justify-center items-center h-40 w-full">
          <HashLoader color="#FF9768" size={70} />
          <div
            style={{
              marginTop: "20px",
              color: "#FF9768",
              fontWeight: "600",
              fontSize: "18px",
            }}
          >
            loading...
          </div>
        </div>
      ) : (
        <div>
          <div className={styles.align}>
            <DataTable
              className="classTable"
              columns={columns}
              data={showList}
              customStyles={customStyles}
              noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
            />
          </div>
          <div>
            <Pagination
              clickForward={() => {
                if (page < totalPage) {
                  setPage(page + 1);
                }
              }}
              clickBackward={() => {
                if (page > 1) {
                  setPage(page - 1);
                }
              }}
              page={page}
              totalpage={totalPage}
            />
          </div>
        </div>
      )}
    </>
  );
};

const CheckResultLab = ({ navigate, setLoading, loading }) => {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [date, setDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([null, null]);
  const [listDate, setListDate] = useState([]);
  const [pid, setPid] = useState("");
  const [labList, setLabList] = useState([]);

  // useEffect(() => {
  //   getDateHistory();
  //   getLabHistory(moment(date).add(543, "years").format("YYYY-MM-DD"), null);
  // }, [date]);

  useEffect(() => {
    const startOfMonth = moment().startOf('month').toDate();
    const today = moment().toDate();

    setDateRange([startOfMonth, today]);

    getLabHistory([startOfMonth, today], null);
    getDateHistory();

  }, []);

  useEffect(() => {
    if (Array.isArray(dateRange) && dateRange[0] && dateRange[1]) {
      
      getLabHistory(dateRange, null);
    }
  }, [dateRange]);

  const [showList, setShowList] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    let start = page * 10 - 10;

    setShowList(labList.slice(start, start + 10));
  }, [page]);

  const getDateHistory = async () => {
    setLoading(true);
    let res = await labPersonalApi.getDateHistory();
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setListDate(
          res["data"]["date_list"].map((item) => {
            return {
              key: item,
              value: moment(item).add(543, "years").format("D MMM YYYY"),
            };
          }),
        );
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const getLabHistory = async (dateRange, pid) => {
    setLoading(true);
    let res = await labPersonalApi.getLabHistory(dateRange, pid);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setLabList(res["data"]["lab_list"]);
        let start = page * 10 - 10;
        setShowList(res.data?.lab_list.slice(start, start + 10));
        setTotalPage(Math.ceil(res.data?.lab_list?.length / 10));
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({ type: "warning", data: res["data"]["message_th"] });
      }
    } else {
      setIsMessage({ type: "warning", data: res["data"]["message_th"] });
    }
  };

  const clickSearch = () => {
    if (!pid) {
      getLabHistory(dateRange, pid);
    } else {
      getLabHistory(null, pid);
    }
  };

  const columns = [
    {
      name: "รหัสตัวอย่าง",
      selector: (i) => <div>{i["testing_no"]}</div>,
      minWidth: "150px",
    },
    {
      name: "เลขบัตรประชาชนผู้ป่วย",
      selector: (i) => <div>{i["id_card"]}</div>,
      minWidth: "210px",
    },
    {
      name: "หมายเลข HN",
      selector: (i) => <div>{i["hn"]}</div>,
      minWidth: "200px",
    },
    {
      name: "คํานําหน้า",
      selector: (i) => <div>{i["sample_name"]["prefix"]}</div>,
    },
    {
      name: "ชื่อ",
      selector: (i) => <div>{i["sample_name"]["first_name"]}</div>,
    },
    {
      name: "นามสกุล",
      selector: (i) => <div>{i["sample_name"]["last_name"]}</div>,
    },
    {
      name: "วันที่ตรวจ",
      selector: (i) => <div>{i["testing_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "วันที่รับตัวอย่าง",
      selector: (i) => <div>{i["receive_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "ชนิดของตัวอย่าง",
      selector: (i) => <div>{i["category"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "วันที่เก็บตัวอย่าง",
      selector: (i) => <div>{i["collect_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "ชื่อหน่วยงานที่ส่งตัวอย่าง",
      selector: (i) => <div>{i["customer_name"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "เลขที่/ ตึกของหน่วยงาน",
      selector: (i) => <div>{i["customer_address"]["address"]}</div>,
      minWidth: "220px",
    },
    {
      name: "ตำบล",
      selector: (i) => <div>{i["customer_address"]["sub_district_name"]}</div>,
    },
    {
      name: "อำเภอ",
      selector: (i) => <div>{i["customer_address"]["district_name"]}</div>,
    },
    {
      name: "จังหวัด",
      selector: (i) => <div>{i["customer_address"]["province_name"]}</div>,
    },
    {
      name: "รหัสไปรษณีย์",
      selector: (i) => <div>{i["customer_address"]["post_code"]}</div>,
      minWidth: "150px",
    },
    {
      name: "ชื่อการทดสอบ",
      selector: (i) => <div>{i["expr2"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "ผลการทดสอบ",
      selector: (i) => <div>{i["testing_result"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "ประเภทผลการทดสอบ",
      selector: (i) => <div>{i["testing_result_type"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "วิธีการทดสอบ",
      selector: (i) => <div>{i["testing_method"]}</div>,
      minWidth: "250px",
      wrap: true,
    },
    {
      name: "เลขที่ใบรายงานผล",
      selector: (i) => <div>{i["report_no"]}</div>,
      minWidth: "150px",
    },
    {
      name: "วันที่รายงานผล",
      selector: (i) => <div>{i["report_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "วันที่ยืนยันผล",
      selector: (i) => <div>{i["approve_date"]}</div>,
      minWidth: "150px",
    },
    {
      name: "เวลาที่ยืนยันผล",
      selector: (i) => <div>{i["approve_time"]}</div>,
      minWidth: "150px",
    },
    {
      name: "ชื่อผู้ตรวจ",
      selector: (i) => (
        <div>
          {i["analyst"]["prefix"]} {i["analyst"]["first_name"]}{" "}
          {i["analyst"]["last_name"]}
        </div>
      ),
      minWidth: "250px",
    },
    {
      name: "ชื่อผู้รับรองผล",
      selector: (i) => (
        <div>
          {i["approver"]["prefix"]} {i["approver"]["first_name"]}{" "}
          {i["approver"]["last_name"]}
        </div>
      ),
      minWidth: "250px",
    },
  ];

  return (
    <>
      <div className={styles.aligntitle}>
        <div className={styles.inputData} style={{ marginRight: "1%" }}>
          {/* <Select
          label="เลือกวันที่"
            placeholder={`${moment(new Date()).add(543, "years").format("D MMM YYYY")} (วันนี้)`}
            value={date}
            setValue={(e) => {
              setDate(e);
              getLabHistory(e, null);
            }}
            list={listDate}
            style={{ borderRadius: "5px" }}
          /> */}
          {/* <Datepicker label="เลือกวันที่" value={date} setValue={setDate} /> */}
          <DateRangePicker 
              label="ช่วงวันที่" 
              value={dateRange} 
              setValue={setDateRange} 
          />
        </div>

        <div className={styles.alignInput} style={{ marginTop: "1rem" }}>
          <div className={styles.inputData} style={{ marginRight: "2%" }}>
            <Input
              placeholder="ค้นหาด้วยเลขบัตรประชาชน"
              value={pid}
              setValue={setPid}
              style={{ borderRadius: "5px" }}
            />
          </div>
          <Button
            onClick={clickSearch}
            style={{ margin: "0", borderRadius: "5px", maxWidth: "200px" }}
          >
            <FaSearch style={{ width: "18px" }} />
            <div style={{ marginLeft: "10px" }}>ค้นหา</div>
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="flex flex-col justify-center items-center h-40 w-full">
          <HashLoader color="#FF9768" size={70} />
          <div
            style={{
              marginTop: "20px",
              color: "#FF9768",
              fontWeight: "600",
              fontSize: "18px",
            }}
          >
            loading...
          </div>
        </div>
      ) : (
        <div>
          <div style={{ marginTop: "3%" }}>
            <DataTable
              className="classTable"
              columns={columns}
              data={showList}
              customStyles={customStyles}
              noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
            />
          </div>
          <div>
            <Pagination
              clickForward={() => {
                if (page < totalPage) {
                  setPage(page + 1);
                }
              }}
              clickBackward={() => {
                if (page > 1) {
                  setPage(page - 1);
                }
              }}
              page={page}
              totalpage={totalPage}
            />
          </div>
        </div>
      )}
    </>
  );
};
